// Tiny mediator that lets the (router-agnostic) api-client redirect to
// /login on refresh failure without importing React Router. A small
// component inside the Router tree registers the navigator on mount;
// until then `redirectToLogin` falls back to a hard `window.location`
// assignment which works in all environments — including tests.

type Navigator = (path: string) => void;

let navigator: Navigator | null = null;

export function registerNavigator(nav: Navigator): void {
  navigator = nav;
}

export function unregisterNavigator(): void {
  navigator = null;
}

export function redirectToLogin(): void {
  if (navigator) {
    navigator("/login");
    return;
  }
  if (typeof window !== "undefined") {
    window.location.href = "/login";
  }
}
